import React from 'react';
import styled from 'styled-components';
import Card from './Card';
import * as api from '../../api';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../Plateforme/Atoms/Spinner';
import InstagramWidgetITW from './InstagramWidgetITW';
import InstagramWidgetTendance from './InstagramWidgetTendance';
import BigH3 from '../Atoms/BigH3';

const CardGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 20px;
    width: 100%;

    /* Desktop - 5 cards in a row */
    @media (min-width: 1201px) {
        & > * {
            flex: 0 0 calc(20% - 16px); /* 5 equal items with gap */
            width: calc(20% - 16px);
        }
    }

    /* Tablet - 3+2 layout */
    @media (min-width: 769px) and (max-width: 1200px) {
        & > *:nth-child(-n+3) { /* First 3 items */
            flex: 0 0 calc(33.333% - 14px);
            width: calc(33.333% - 14px);
        }
        & > *:nth-child(n+4) { /* Last 2 items */
            flex: 0 0 calc(50% - 10px);
            width: calc(33.333% - 14px);
        }
    }

    /* Mobile - stacked */
    @media (max-width: 768px) {
        & > * {
            flex: 0 0 100%;
            width: 100%;
        }
    }
`;

const CardWrapper = styled.div`
    display: flex;
    min-height: 400px; /* Set a minimum height for all cards */
    
    & > * {
        width: 100%;
        height: 100%;
    }
`;

const InstagramContainer = styled.div`
    position: relative;
    border: solid 1px black;
    display: flex;
    flex-direction: column;
    min-height: 400px;
    transition: transform 0.2s ease-in-out;

    &:hover {
        transform: scale(1.05); /* Slight zoom effect */
    }
`;

const ActualitesSection = styled.div`
    width: 100%;
    padding: 40px;
    display: flex;
    flex-direction: column;
`;

const Tag = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    background: white;
    border: 1px solid black;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    z-index: 99;
`;

const News = () => {
    const navigate = useNavigate();
    const [profile, setProfile] = React.useState(null);
    const [company, setCompany] = React.useState(null);
    const [project, setProject] = React.useState(null);

    React.useEffect(() => {
        api.GetHomepageProfile()
            .then((response) => {
                setProfile(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
        api.GetHomepageCompany()
            .then((response) => {
                setCompany(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
        api.GetHomepageProject()
            .then((response) => {
                setProject(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    return (
        <ActualitesSection>
            <BigH3>Découvrez les dernières nouveautés à la une</BigH3>
            <CardGrid>
                <CardWrapper>
                    {profile ? (
                        <Card
                            image={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + profile?.image}
                            tag={profile?.tag}
                            title={profile?.title}
                            description={profile?.description}
                            onClick={() => navigate(profile?.link)}
                        />
                    ) : (
                        <Spinner />
                    )}
                </CardWrapper>
                <CardWrapper>
                    {company ? (
                        <Card
                            image={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + company?.image}
                            tag={company?.tag}
                            title={company?.title}
                            description={company?.description}
                            onClick={() => navigate(company?.link)}
                        />
                    ) : (
                        <Spinner />
                    )}
                </CardWrapper>
                <CardWrapper>
                    {project ? (
                        <Card
                            image={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + project?.image}
                            tag={project?.tag}
                            title={project?.title}
                            description={project?.description}
                            onClick={() => navigate(project?.link)}
                        />
                    ) : (
                        <Spinner />
                    )}
                </CardWrapper>
                <InstagramContainer>
                    <Tag>Tendances</Tag>
                    <InstagramWidgetTendance />
                </InstagramContainer>
                <InstagramContainer>
                    <Tag>Interview</Tag>
                    <InstagramWidgetITW />
                </InstagramContainer>
            </CardGrid>
        </ActualitesSection>
    );
};

export default News;